// extracted by mini-css-extract-plugin
module.exports = {"customer-list-item":"CustomerListItem_customer-list-item__1fKDE","header":"CustomerListItem_header__2IPw8","customer-info":"CustomerListItem_customer-info__14XSL"};